export default __webpack_public_path__ + "static/favicon-512-a9b93715a2f966d93be8ad274ddc22bd.png";